/**
 * Ashore API
 * All Endpoints to control your ashore account
 *
 * The version of the OpenAPI document: V1
 * Contact: info@ashoreapp.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import JobTag from './JobTag';
import JobTagLink from './JobTagLink';
import Priority from './Priority';

/**
 * The JobWithPosition model module.
 * @module model/JobWithPosition
 * @version V1
 */
class JobWithPosition {
    /**
     * Constructs a new <code>JobWithPosition</code>.
     * @alias module:model/JobWithPosition
     */
    constructor() { 
        
        JobWithPosition.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>JobWithPosition</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/JobWithPosition} obj Optional instance to populate.
     * @return {module:model/JobWithPosition} The populated <code>JobWithPosition</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new JobWithPosition();

            if (data.hasOwnProperty('position')) {
                obj['position'] = ApiClient.convertToType(data['position'], 'String');
            }
            if (data.hasOwnProperty('displayPosition')) {
                obj['displayPosition'] = ApiClient.convertToType(data['displayPosition'], 'Number');
            }
            if (data.hasOwnProperty('id')) {
                obj['id'] = ApiClient.convertToType(data['id'], 'Number');
            }
            if (data.hasOwnProperty('jobNumber')) {
                obj['jobNumber'] = ApiClient.convertToType(data['jobNumber'], 'String');
            }
            if (data.hasOwnProperty('name')) {
                obj['name'] = ApiClient.convertToType(data['name'], 'String');
            }
            if (data.hasOwnProperty('assignee')) {
                obj['assignee'] = ApiClient.convertToType(data['assignee'], 'Number');
            }
            if (data.hasOwnProperty('description')) {
                obj['description'] = ApiClient.convertToType(data['description'], 'String');
            }
            if (data.hasOwnProperty('createdAt')) {
                obj['createdAt'] = ApiClient.convertToType(data['createdAt'], 'Date');
            }
            if (data.hasOwnProperty('updatedAt')) {
                obj['updatedAt'] = ApiClient.convertToType(data['updatedAt'], 'Date');
            }
            if (data.hasOwnProperty('status')) {
                obj['status'] = ApiClient.convertToType(data['status'], 'Number');
            }
            if (data.hasOwnProperty('priority')) {
                obj['priority'] = Priority.constructFromObject(data['priority']);
            }
            if (data.hasOwnProperty('startDate')) {
                obj['startDate'] = ApiClient.convertToType(data['startDate'], 'Date');
            }
            if (data.hasOwnProperty('endDate')) {
                obj['endDate'] = ApiClient.convertToType(data['endDate'], 'Date');
            }
            if (data.hasOwnProperty('accountId')) {
                obj['accountId'] = ApiClient.convertToType(data['accountId'], 'Number');
            }
            if (data.hasOwnProperty('createdBy')) {
                obj['createdBy'] = ApiClient.convertToType(data['createdBy'], 'Number');
            }
            if (data.hasOwnProperty('updatedBy')) {
                obj['updatedBy'] = ApiClient.convertToType(data['updatedBy'], 'Number');
            }
            if (data.hasOwnProperty('jobTags')) {
                obj['jobTags'] = ApiClient.convertToType(data['jobTags'], [JobTag]);
            }
            if (data.hasOwnProperty('jobTagLinks')) {
                obj['jobTagLinks'] = ApiClient.convertToType(data['jobTagLinks'], [JobTagLink]);
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>JobWithPosition</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>JobWithPosition</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['position'] && !(typeof data['position'] === 'string' || data['position'] instanceof String)) {
            throw new Error("Expected the field `position` to be a primitive type in the JSON string but got " + data['position']);
        }
        // ensure the json data is a string
        if (data['jobNumber'] && !(typeof data['jobNumber'] === 'string' || data['jobNumber'] instanceof String)) {
            throw new Error("Expected the field `jobNumber` to be a primitive type in the JSON string but got " + data['jobNumber']);
        }
        // ensure the json data is a string
        if (data['name'] && !(typeof data['name'] === 'string' || data['name'] instanceof String)) {
            throw new Error("Expected the field `name` to be a primitive type in the JSON string but got " + data['name']);
        }
        // ensure the json data is a string
        if (data['description'] && !(typeof data['description'] === 'string' || data['description'] instanceof String)) {
            throw new Error("Expected the field `description` to be a primitive type in the JSON string but got " + data['description']);
        }
        if (data['jobTags']) { // data not null
            // ensure the json data is an array
            if (!Array.isArray(data['jobTags'])) {
                throw new Error("Expected the field `jobTags` to be an array in the JSON data but got " + data['jobTags']);
            }
            // validate the optional field `jobTags` (array)
            for (const item of data['jobTags']) {
                JobTag.validateJSON(item);
            };
        }
        if (data['jobTagLinks']) { // data not null
            // ensure the json data is an array
            if (!Array.isArray(data['jobTagLinks'])) {
                throw new Error("Expected the field `jobTagLinks` to be an array in the JSON data but got " + data['jobTagLinks']);
            }
            // validate the optional field `jobTagLinks` (array)
            for (const item of data['jobTagLinks']) {
                JobTagLink.validateJSON(item);
            };
        }

        return true;
    }


}



/**
 * @member {String} position
 */
JobWithPosition.prototype['position'] = undefined;

/**
 * @member {Number} displayPosition
 */
JobWithPosition.prototype['displayPosition'] = undefined;

/**
 * @member {Number} id
 */
JobWithPosition.prototype['id'] = undefined;

/**
 * @member {String} jobNumber
 */
JobWithPosition.prototype['jobNumber'] = undefined;

/**
 * @member {String} name
 */
JobWithPosition.prototype['name'] = undefined;

/**
 * @member {Number} assignee
 */
JobWithPosition.prototype['assignee'] = undefined;

/**
 * @member {String} description
 */
JobWithPosition.prototype['description'] = undefined;

/**
 * @member {Date} createdAt
 */
JobWithPosition.prototype['createdAt'] = undefined;

/**
 * @member {Date} updatedAt
 */
JobWithPosition.prototype['updatedAt'] = undefined;

/**
 * @member {Number} status
 */
JobWithPosition.prototype['status'] = undefined;

/**
 * @member {module:model/Priority} priority
 */
JobWithPosition.prototype['priority'] = undefined;

/**
 * @member {Date} startDate
 */
JobWithPosition.prototype['startDate'] = undefined;

/**
 * @member {Date} endDate
 */
JobWithPosition.prototype['endDate'] = undefined;

/**
 * @member {Number} accountId
 */
JobWithPosition.prototype['accountId'] = undefined;

/**
 * @member {Number} createdBy
 */
JobWithPosition.prototype['createdBy'] = undefined;

/**
 * @member {Number} updatedBy
 */
JobWithPosition.prototype['updatedBy'] = undefined;

/**
 * @member {Array.<module:model/JobTag>} jobTags
 */
JobWithPosition.prototype['jobTags'] = undefined;

/**
 * @member {Array.<module:model/JobTagLink>} jobTagLinks
 */
JobWithPosition.prototype['jobTagLinks'] = undefined;






export default JobWithPosition;

